<template>
  <b-overlay
    :variant="variant"
    :opacity="opacity"
    :blur="blur"
    :show="loading"
    no-wrap
  >
    <template v-slot:overlay>
      <div class="d-flex flex-column justify-content-center align-items-center">
        <b-spinner variant="primary" />
        <br />
        <span class="h3 text-primary">{{ text }}</span>
      </div>
    </template>
  </b-overlay>
</template>

<script>
import { BSpinner, BOverlay } from "bootstrap-vue";
export default {
  components: {
    BSpinner,
    BOverlay,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: "transparent",
    },
    blur: {
      type: String,
      default: "3px",
    },
    opacity: {
      type: Number,
      default: 1,
    },
    text: {
      type: String,
      default: "کمی صبر کنید",
    },
  },
};
</script>

<style></style>
